import Vue from 'vue'
import './utils/COVERAPP'
import App from './App.vue'
import router from './router'
import store from './store'
import './index.scss'
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
